<template>
    <v-dialog v-model="paymentDialog" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn :color="primaryColor" block dark v-bind="attrs" v-on="on" @click="initializePaymentForm()">
                <v-icon left>mdi-credit-card-outline</v-icon> Make An Online Payment
            </v-btn>
        </template>
        <v-card>
            <v-toolbar dark :color="primaryColor">
                <v-btn icon @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    <v-icon>mdi-credit-card-outline</v-icon> Make An Online Payment
                </v-toolbar-title>
            </v-toolbar>
            <v-overlay absolute="" opacity="0.2" :value="loader">
                <v-progress-circular :color="kingsGreen" indeterminate size="32"></v-progress-circular>
            </v-overlay>
            <v-card class="mt-5 mx-auto" flat :loading="processing" width="767px">
                <v-card-text class="fill-height">
                    <form id="payment-form">
                        <section class="mb-4">
                            <div class="product">
                                <img src="../../../../assets/images/residence-min.png"
                                    alt="Residence Confirmation Deposit" width="100%" />
                                <div class="description">
                                    <h3>Residence Confirmation Deposit</h3>
                                    <h5>$1000.00 CAD</h5>
                                </div>
                            </div>
                        </section>
                        <div id="card-element">
                        </div>
                        <button ref="paymentButton" id="submit" class="mt-3" :disabled="processing">
                            <span v-if="processing">
                                Processing Payment...
                            </span>
                            <span v-else id="button-text" class="white--text">
                                <v-icon dark>mdi-credit-card-check-outline</v-icon> Pay Deposit
                            </span>
                        </button>
                        <p ref="cardError" id="card-error" role="alert"></p>
                    </form>
                </v-card-text>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    loadStripe
} from '@stripe/stripe-js';

export default {
    name: 'online-payment',
    props: {
        applicant: {
            required: true
        },
        paymentProcessed: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            card: '',
            loader: true,
            paymentDialog: false,
            processing: false
        }
    },
    methods: {
        closeDialog() {
            if (this.card) {
                this.card.clear();
            }

            this.paymentDialog = false;
        },
        async initializePaymentForm() {
            // Ensure only one card element is mounted
            if (!this.card) {
                const that = this;
                let api = `https://${location.hostname}/cgi-bin/res-app-api/payment.processor.py`;
                const formData = new FormData();
                const key = location.hostname.match(/(rach.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi) ?
                    'pk_test_51HcEI6FQaJNnD5xgIAYpZdyKOJoGQUvSEjxIYcnXNVL0sErDqfnn9QIkOWxhdCerD0A8bgRYMHRo4FB2oKYnxqFp00yRxOB2xi' :
                    'pk_live_51HcEI6FQaJNnD5xg28dG6lEEqS1suKaOW9Z6aySh70fT6txizbC7fIr6q7exWI1vEP9GBlEARNuD1LM1LlVsePSw00SMLNXE4Y';
                const stripe = await loadStripe(key);


                let stripeDescription = "Residence Deposit"

                //Nov 7, 2025 Update (KUC-10459) - Stripe Description to be dynamic depending on the building choice of the applicant

                let buildingOption1Check = /Epworth Place/i.test(this.applicant.buildingOption01) || /King's Commons/i.test(this.applicant.buildingOption01);
                let buildingOption2Check = /Epworth Place/i.test(this.applicant.buildingOption02) || /King's Commons/i.test(this.applicant.buildingOption02);
                let upperyear = ["2", "3", "4"]
                let yearofStudyCheck = upperyear.includes(this.applicant.yearOfStudy)

                if(yearofStudyCheck && (buildingOption1Check || buildingOption2Check)){
                    stripeDescription = "Residence Deposit King’s Commons / Epworth Place Condos"
                }

                //End of building choice check

                // Stripe data
                formData.append('data', JSON.stringify({
                    emailPersonal: this.applicant.emailPersonal,
                    firstName: this.applicant.firstName,
                    items: [{
                        item: "Residence Deposit"
                    }],
                    lastName: this.applicant.lastName,
                    studentnumber: this.applicant.studentnumber,
                    stripeDescription: stripeDescription
                }));

                // Post request
                fetch(api, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (json) {
                        // Create stripe elements
                        let elements = stripe.elements({
                            locale: 'auto'
                        });
                        let style = {
                            base: {
                                color: "#1d2127",
                                fontSmoothing: "antialiased",
                                fontSize: "16px",
                                "::placeholder": {
                                    color: "#1d2127"
                                }
                            },
                            invalid: {
                                color: "#f64e60",
                                iconColor: "#f64e60"
                            }
                        };
                        that.card = elements.create("card", {
                            style: style
                        });

                        // Stripe injects an iframe into the DOM
                        that.card.mount("#card-element");
                        that.card.on("change", function (event) {
                            // Disable the Pay button if there are no card details in the Element
                            document.querySelector("#submit").disabled = event.empty;
                            document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
                        });

                        // Bind payment processor
                        let form = document.getElementById("payment-form");
                        form.addEventListener("submit", function (event) {
                            event.preventDefault();
                            // Complete payment when the submit button is clicked
                            that.payWithCard(stripe, that.card, json.data.client_secret);
                        });

                        that.loader = false;
                    })
                    .catch(function () {
                        that.loader = false;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                    });
            }
        },
        payWithCard(stripe, card, clientSecret) {
            let that = this;

            // Processing loader
            this.processing = true;

            // Proccess payment
            stripe
                .confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: card
                    }
                })
                .then(function (result) {
                    if (result.error) {
                        // Show error to your customer
                        var errorMsg = document.querySelector("#card-error");
                        errorMsg.textContent = result.error.message;
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', result.error.message, true);
                        that.processing = false;

                        // Remove error message after 5 seconds
                        setTimeout(function () {
                            errorMsg.textContent = "";
                        }, 5000);
                    } else {
                        // The payment succeeded!
                        that.$emit('setCreditCardPayment');
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check', `The credit card payment has been successfully processed.`, true);
                        that.processing = false;
                    }
                });
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGreen() {
            return '#004236';
        },
        primaryColor() {
            return '#5867dd';
        }
    }
}
</script>

<style scoped>
/* Buttons and links */
button {
    background: #5469d4;
    color: #ffffff;
    font-family: Arial, sans-serif;
    border-radius: 0 0 4px 4px;
    border: 0;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
}

button:hover {
    filter: contrast(115%);
}

button:disabled {
    opacity: 0.5;
    cursor: default;
}

.hidden {
    display: none;
}

input {
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    font-size: 16px;
    width: 100%;
    background: white;
}

#card-error {
    /* color: rgb(105, 115, 134); */
    color: #f64e60;
    text-align: left;
    font-size: 13px;
    line-height: 17px;
    margin-top: 12px;
}

#card-element {
    border-radius: 4px 4px 0 0;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    width: 100%;
    background: white;
}

#payment-request-button {
    margin-bottom: 32px;
}
</style>